import { GetApp } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { FullStudyReportDomain } from './store/FullStudyReportDomain';
import { StudyReportNavbarUI } from './store/StudyReportNavbarUI';
import { useI18n } from '../../../../application/language/useI18n';
import { IProjectLearningReportArg } from '../../../../service/report/interface/IProjectLearningReportArg';

type IStudyReportNavbarProperties = {
  reportArg?: IProjectLearningReportArg;
  userMode?: boolean;
};

export const StudyReportNavbar = observer(({ reportArg = {}, userMode = false }: IStudyReportNavbarProperties) => {
  const { translate } = useI18n();

  const [{ isFetching, exportUnitsReport, exportEmployeesReport }] = useState(
    () => new StudyReportNavbarUI(new FullStudyReportDomain(), reportArg),
  );

const handleEmployeesReport = async () => {
  closeMenu();
  await exportEmployeesReport();
};

const handleUnitsReport = async () => {
  closeMenu();
  await exportUnitsReport();
};

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  if (userMode) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          startIcon={<GetApp />}
          onClick={handleUnitsReport}
          disabled={isFetching.value}
        >
          {translate('analytics.exportUserReport')}
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant="contained"
        startIcon={<GetApp />}
        onClick={openMenu}
        disabled={isFetching.value}
      >
        {translate('analytics.exportReports')}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleEmployeesReport}>
          {translate('analytics.exportEmployeesReport')}
        </MenuItem>

        <MenuItem onClick={handleUnitsReport}>
          {translate('analytics.exportUnitsReport')}
        </MenuItem>
      </Menu>
    </Box>
  );
});
